export default __webpack_public_path__ + "static/media/flower.efe3239b.svg";